import type { Image as ImageType } from 'types/capi/shared';

import Tracked from '~/components/Tracked';
import gtm from '~/services/gtm.client';

import ExitNotificationDialog from './ExitNotificationDialog';

type Props = {
  image?: ImageType;
  onCancel: () => void;
  onGoBack: () => void;
};

export default function CancelNotifications({
  image,
  onGoBack,
  onCancel
}: Props) {
  function handleBackgroundDismiss() {
    gtm.trackedButtonClick({
      buttonName: 'CANCEL_NOTIFICATIONS',
      pagePosition: 'Cancel modal'
    });
    onCancel();
  }

  return (
    <ExitNotificationDialog
      heading="Cancel notifications?"
      image={image}
      onDismiss={handleBackgroundDismiss}
    >
      <p>
        Are you sure you don&apos;t want to get notified when these are in
        stock?
      </p>
      <div className="flex w-full flex-col gap-4">
        <Tracked.Button
          variant="forest"
          className="h-12 w-full"
          onClick={onGoBack}
          name="I_WANT_NOTIFICATIONS"
          pagePosition="Cancel modal"
        >
          I want notifications
        </Tracked.Button>
        <Tracked.Button
          variant="transparent-black-border"
          className="h-12 w-full"
          onClick={onCancel}
          name="CANCEL_NOTIFICATIONS"
          pagePosition="Cancel modal"
        >
          Cancel notifications
        </Tracked.Button>
      </div>
    </ExitNotificationDialog>
  );
}
